import { all } from "redux-saga/effects";

//public
import AuthenticationSaga from "./authentication/saga";
import settingsSaga from "./settings/saga";
import contactTypesSaga from "./contactTypes/saga";
import categoriesSaga from "./categories/saga";
import applicationsSaga from "./applications/saga";
import themesSaga from "./themes/saga";
import subscriptionsSaga from "./subscriptions/saga";
import coupons from "./coupons/saga";
import payments from "./payments/saga";
import employees from "./employees/saga";
import data from "./data/saga";
import paymentMethods from "./paymentMethods/saga";
import demoStores from "./demoStores/saga";
import webhooks from "./webhooks/saga";
import customPlans from "./applications/customPlans/saga";
import reviews from "./applications/reviews/saga";

export default function* rootSaga() {
  yield all([
    AuthenticationSaga(),
    settingsSaga(),
    contactTypesSaga(),
    applicationsSaga(),
    categoriesSaga(),
    themesSaga(),
    subscriptionsSaga(),
    coupons(),
    payments(),
    employees(),
    data(),
    paymentMethods(),
    demoStores(),
    webhooks(),
    customPlans(),
    reviews(),
  ]);
}
